import { render } from "./BaseContainer.vue?vue&type=template&id=04b77eea&scoped=true"
const script = {}

import "./style.less?vue&type=style&index=0&id=04b77eea&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b77eea"]])

export default __exports__